import script from "./page-header.vue?vue&type=script&setup=true&lang=js"
export * from "./page-header.vue?vue&type=script&setup=true&lang=js"

import "./page-header.vue?vue&type=style&index=0&id=008275e6&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008275e6"]])

export default __exports__